import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDarkMode } from '../contexts/DarkModeContext';
import useAuthStore from '../store/authStore';

// Icons for the buttons
const ContactIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
  </svg>
);

const CartIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <path fill="currentColor" d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
  </svg>
);

const ProductViewFooterBar = ({ 
  product, 
  onContactSeller, 
  onBuyNow, 
  contactLoading = false,
  isInStock = true 
}) => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  // Handle buy now click
  const handleBuyNow = () => {
    if (onBuyNow) {
      onBuyNow();
    } else {
      // Default behavior - navigate to checkout
      navigate('/checkout', { state: { product } });
    }
  };

  // Handle contact seller click
  const handleContactSeller = () => {
    if (onContactSeller) {
      onContactSeller();
    }
  };

  return (
    <div className="fixed bottom-16 left-0 right-0 z-40 md:hidden w-full">
      <div className={`flex gap-2 shadow-xl px-3 py-2 backdrop-blur ${
        isDarkMode 
          ? 'bg-[#1a1a1a]/95 border border-gray-800' 
          : 'bg-white/95 border border-gray-200'
      }`}>
        {/* Contact Seller Button */}
        <button
          onClick={handleContactSeller}
          disabled={contactLoading}
          className={`flex-1 flex items-center justify-center gap-1.5 text-white font-medium rounded-lg py-2 px-3 transition-all duration-200 shadow hover:shadow-lg ${
            isDarkMode 
              ? 'bg-[#034d3f] hover:bg-[#023a2f] disabled:bg-[#034d3f]' 
              : 'bg-green-500 hover:bg-green-600 disabled:bg-green-500'
          }`}
        >
          <ContactIcon className="w-4 h-4" />
          <span className="text-xs font-medium">
            {contactLoading ? 'Starting...' : 'Contact Seller'}
          </span>
        </button>

        {/* Buy Now Button */}
        <button
          onClick={handleBuyNow}
          disabled={!isInStock || user?.isBanned}
          className={`flex-1 flex items-center justify-center gap-1.5 font-bold rounded-lg py-2 px-3 transition-all duration-200 shadow hover:shadow-lg ${
            !isInStock || user?.isBanned
              ? 'bg-gray-500 text-white cursor-not-allowed'
              : 'bg-red-600 hover:bg-red-700 text-white'
          }`}
        >
          <CartIcon className="w-4 h-4" />
          <span className="text-xs font-medium">
            {!isInStock ? 'Out of Stock' : (user?.isBanned ? 'Buy Now' : 'Buy Now')}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProductViewFooterBar;